import { Either, Option } from 'funfix-core';
import { FETCH_INSTALLABLE_APP_FOR_UPGRADE_ERROR, FINISH_FETCH_INSTALLABLE_APP_FOR_UPGRADE, FINISH_UPGRADE_APP, START_UPGRADE_APP, UPGRADE_APP_ERROR } from '../../actions/Installation/UpgradeApp';
import { foldInstallMode } from '../../records/InstallMode/InstallMode';
import { makeCompleteInstallStatus, makeInProgressInstallStatus } from '../../records/InstallMode/InstallStatus';
import { flatMapInstallMode, mapInstallMode } from './InstallationUtils';
// eslint-disable-next-line max-lines-per-function -- Fix me
const upgradeAppReducer = (state, action) => {
  switch (action.type) {
    case FINISH_FETCH_INSTALLABLE_APP_FOR_UPGRADE:
      {
        const installableAppByKeyId = action.installableAppByKeyId;
        const installableAppToUpgradeTo = action.installableAppToUpgradeTo;
        return mapInstallMode(state, currentInstallMode => foldInstallMode(currentInstallMode)(value => value, value => value, value => value, value => value, value => value, installableAppUpgrade => installableAppUpgrade.installableAppByKeyId.equals(installableAppByKeyId) ? installableAppUpgrade.set('installableAppToUpgradeTo', Option.some(Either.right(installableAppToUpgradeTo))) : installableAppUpgrade));
      }
    case FETCH_INSTALLABLE_APP_FOR_UPGRADE_ERROR:
      {
        const installableAppByKeyId = action.installableAppByKeyId;
        const error = action.error;
        return mapInstallMode(state, currentInstallMode => foldInstallMode(currentInstallMode)(value => value, value => value, value => value, value => value, value => value, installableAppUpgrade => installableAppUpgrade.installableAppByKeyId.equals(installableAppByKeyId) ? installableAppUpgrade.set('installableAppToUpgradeTo', Option.some(Either.left(error))) : installableAppUpgrade));
      }
    case START_UPGRADE_APP:
      {
        const installableAppByKeyId = action.installableAppByKeyId;
        return mapInstallMode(state, currentInstallMode => foldInstallMode(currentInstallMode)(value => value, value => value, value => value, value => value, value => value, installableAppUpgrade => installableAppUpgrade.installableAppByKeyId.equals(installableAppByKeyId) ? installableAppUpgrade.set('status', makeInProgressInstallStatus()) : installableAppUpgrade));
      }
    case FINISH_UPGRADE_APP:
      {
        const installableAppByKeyId = action.installableAppByKeyId;
        return flatMapInstallMode(state, currentInstallMode => foldInstallMode(currentInstallMode)(Option.some, Option.some, Option.some, Option.some, Option.some, installableAppUpgrade => installableAppUpgrade.installableAppByKeyId.equals(installableAppByKeyId) ? Option.none() : Option.some(installableAppUpgrade)));
      }
    case UPGRADE_APP_ERROR:
      {
        const installableAppByKeyId = action.installableAppByKeyId;
        const error = action.error;
        return mapInstallMode(state, currentInstallMode => foldInstallMode(currentInstallMode)(value => value, value => value, value => value, value => value, value => value, installableAppUpgrade => installableAppUpgrade.installableAppByKeyId.equals(installableAppByKeyId) ? installableAppUpgrade.set('status', makeCompleteInstallStatus({
          result: Either.left(error)
        })) : installableAppUpgrade));
      }
    default:
      // Flow compile-time validation that we've handled every action
      // prettier-ignore
      action;
      return state;
  }
};
export default upgradeAppReducer;